import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { SocketIoService } from './socket.io.service';
import { recieveCopyShareJobDone, setShareCopyStatus, ShareCopyStatus } from '../share/share.actions';
import { ShareErrorsService } from '../share/share-errors.service';
import { setIsSocketConnected } from "../visual/visual.actions";

@Component({
  selector: 'nns-socket-io',
  template: `
    <ng-content></ng-content>
  `
})

export class SocketIoComponent implements OnInit, OnDestroy {
  @Input() shareCopy;
  constructor(
    public _store: Store<IAppState>,
    public _socketIo: SocketIoService,
    private _shareErrorsService: ShareErrorsService,
  ) { }

  ngOnInit() {
    this._socketIo.connect();

    const socketMessages$ = this._socketIo.getMessages();

    const isSocketConnected$ = this._socketIo.getIsConnected();

    if (socketMessages$) {
      socketMessages$
        .filter((event) => {
          const jobId = event.data.message.uuid;
          console.log('[save] completed', jobId)
          return this.shareCopy.shareCopyJobId === jobId;
        })
        .map((event) => {
          if(event.eventName == 'job:success') {
            this._store.dispatch(recieveCopyShareJobDone());
          } else if('job:error') {
            this._shareErrorsService.showError(event.data);
            this._store.dispatch(recieveCopyShareJobDone());
            this._store.dispatch(setShareCopyStatus(ShareCopyStatus.SHARE_COPY_INITIAL));
          }
          return event;
        })
        .delay(2000)
        .forEach((event) => {
          if(event.eventName == 'job:error') {
            this._store.dispatch(setShareCopyStatus(ShareCopyStatus.SHARE_COPY_INITIAL));
          }
        });
    }

    if(isSocketConnected$) {
      isSocketConnected$
        .forEach((isConnected) => {
          this._store.dispatch(setIsSocketConnected(isConnected));
        });
    }
  }

  ngOnDestroy() {
     this._socketIo.disconnect();
  }
}
